module.exports = __webpack_public_path__ + "img/oil_industry.353a85d4.svg";